import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a608132")

_pushScopeId("data-v-2a608132")
const _hoisted_1 = { class: "landing" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "welcome" }, "Welcome to", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title" }, "The Showcase", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "description" }, "The goal of this space is to present different ideas I have for UI/UX design and small CSS or JS projects.", -1)
const _hoisted_5 = { class: "github" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("You can check out the source code on ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("!")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LinkIcon = _resolveComponent("LinkIcon")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("p", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_LinkIcon, {
        href: 'https://github.com/nkooman/the-showcase/',
        title: 'Link to the GitHub repository',
        text: 'GitHub',
        "icon-before": 'link',
        "is-external": true
      }, null, 8, ["href"]),
      _hoisted_7
    ])
  ]))
})